/**
 * SPEC-023 — Friendly error messages
 *
 * Maps HTTP status codes and known error identifiers to user-friendly
 * descriptions. Falls through to the raw message for unmapped values.
 *
 * Usage:
 *   import { friendlyMessage } from '../utils/errorMessages';
 *   const msg = friendlyMessage(res.status, data.error);
 */

const MESSAGE_MAP: Record<number | string, string> = {
  401: 'Your session has expired. Please sign in again.',
  402: 'Your transcription balance is empty. Top up to continue.',
  403: "You don't have permission for that action.",
  413: 'That file is too large. Please compress it first.',
  429: 'Too many requests — please wait a moment and try again.',
  500: 'Something went wrong on our end. Please try again.',
  503: 'Transcription service temporarily unavailable. Please try again shortly.',
  network: 'No network connection. Check your internet and try again.',
};

/**
 * Returns a user-friendly message for the given error code.
 * Falls through to `raw` if no mapping is found.
 *
 * @param code - HTTP status code (number) or named error key (string)
 * @param raw  - Original error message to display as fallback
 */
export function friendlyMessage(code: number | string, raw?: string): string {
  return MESSAGE_MAP[code] ?? raw ?? 'An unexpected error occurred.';
}
